export enum channelEnum {
  HAI = 'hai',
  INTEGRATION = 'integration', // 被集成
  SP = 'sp', // workspace 重定向逻辑; (space的前面2个字母缩写)
}

export const roleName = `CLOUDSTUDIO_QCSLinkedRoleInHaiws`;

export const haiAuthorizationUrl = `https://console.cloud.tencent.com/cam/role/grant?roleName=${roleName}&serviceLinkedRole=1&s_url=${encodeURIComponent(location.href)}`;

export const onSignTokenScene = 'app';
